export default __webpack_public_path__ + "static/media/SCANIA_GESTION_EN_EL_TALLER.898b927d.pdf";